module.exports = __webpack_public_path__ + "static/media/icon.58fd7f27.png";